module.exports = __webpack_public_path__ + "img/anthony-cornett.201315e7.jpg";